import React from 'react';

// Material components
import {
    Chip,
    Select,
    MenuItem,
    TableCell
} from '@material-ui/core';

import { TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import { CheckBox } from 'devextreme-react';

//icons
import GreaterThan from '@material-ui/icons/NavigateBefore';
import LessThan from '@material-ui/icons/NavigateNext';
import Equals from '@material-ui/icons/DragHandle';

import { DataTypeProvider, IntegratedFiltering } from '@devexpress/dx-react-grid';

import { CustomDateFilter } from './CustomDateFilter';

// utils
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';
import sub from 'date-fns/sub';
import isValid from 'date-fns/isValid';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    detailContainer: {
        margin: '10px',
    },
    licenzaBloccata: {
        color: '#fff',
        backgroundColor: '#d9534f'
    },
    licenzaAttiva: {
        color: '#fff',
        backgroundColor: '#5cb85c'
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    checkBoxMultiAzienda: {
        color: '#fff',
        backgroundColor: '#95f595'
    },
});


//Personalizzazione funzionalita filtri colonne
export const filtersMessages = {
    lessThan: 'Minore di',
    greaterThan: 'Maggiore di',

};


//NB: non c'e un modo per avere lo stesso comportamento per columnName diversi, perci� bisogna fare brutalmente copia incolla per tutte le colonne in cui voglio il filtro personalizzato
export const filteringColumnExtensions = [
    {
        columnName: 'DataScadenza',
        predicate: (cellValue, filter, row) => {

            /*  cellValue = string valore cella
             *  filter = oggetto filtro riga con struttura {columnName: string, value: object datetime, operation: string}
             *  row = oggetto contenente tutti i campi della riga che contiene la cella da filtrare
            */

            if (!filter.value) return true;


            if (filter) {

                if (isValid(new Date(filter.value))) {
                    //pulisco le date dal time in modo da fare il check solo sulla data
                    var cellValueDate = null;
                    var cellValueFormattedDate = null;

                    if (cellValue !== null) {
                        var cellValueDate = new Date(cellValue);
                        var cellValueFormattedDate = parseISO(format(cellValueDate, 'yyyy-MM-dd'));
                    }

                    var filterValueFormattedDate = parseISO(format(filter.value, 'yyyy-MM-dd'));

                    /*
                    console.log("***********", row.ProductKey);
                    console.log("cellValue: ", cellValue);
                    console.log("cellValueDate: ", cellValueDate);
                    console.log("cellValueFormattedDate: ", cellValueFormattedDate);
    
                    console.log("filter.value: ", filter.value);
                    console.log("filterValueFormattedDate: ", filterValueFormattedDate);
                    console.log("sub: ", sub(filterValueFormattedDate, { minutes: 1 }));
                    console.log("add: ", add(filterValueFormattedDate, { minutes: 1 }));
    
                    console.log("-------------------------");
                    */

                    if (filter.operation === 'greaterThan') {
                        //se cellValue === null allora la licenza non ha data scadenza
                        if (cellValue === null) return true;
                        else return isAfter(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'lessThan') {
                        if (cellValue === null) return false;
                        else return isBefore(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'equal') {
                        return isEqual(cellValueFormattedDate, filterValueFormattedDate);
                    }
                    else return false;
                }
                else return true;
            }
            else return false;

        },
    },
    {
        columnName: 'DataDecorr',
        predicate: (cellValue, filter, row) => {

            if (!filter.value) return true;

            if (filter) {

                if (isValid(new Date(filter.value))) {
                    //pulisco le date dal time in modo da fare il check solo sulla data
                    var cellValueDate = null;
                    var cellValueFormattedDate = null;

                    if (cellValue !== null) {
                        var cellValueDate = new Date(cellValue);
                        var cellValueFormattedDate = parseISO(format(cellValueDate, 'yyyy-MM-dd'));
                    }

                    var filterValueFormattedDate = parseISO(format(filter.value, 'yyyy-MM-dd'));

                    if (filter.operation === 'greaterThan') {
                        //se cellValue === null allora la licenza non ha data scadenza
                        if (cellValue === null) return true;
                        else return isAfter(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'lessThan') {
                        if (cellValue === null) return false;
                        else return isBefore(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'equal') {
                        return isEqual(cellValueFormattedDate, filterValueFormattedDate);
                    }
                    else return false;
                }
                else return true;
            }
            else return false;

        },
    },
    {
        columnName: 'DataAttivazione',
        predicate: (cellValue, filter, row) => {

            if (!filter.value) return true;

            if (filter) {

                if (isValid(new Date(filter.value))) {
                    //pulisco le date dal time in modo da fare il check solo sulla data
                    var cellValueDate = null;
                    var cellValueFormattedDate = null;

                    if (cellValue !== null) {
                        var cellValueDate = new Date(cellValue);
                        var cellValueFormattedDate = parseISO(format(cellValueDate, 'yyyy-MM-dd'));
                    }

                    var filterValueFormattedDate = parseISO(format(filter.value, 'yyyy-MM-dd'));

                    if (filter.operation === 'greaterThan') {
                        //se cellValue === null allora la licenza non ha data scadenza
                        if (cellValue === null) return true;
                        else return isAfter(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'lessThan') {
                        if (cellValue === null) return false;
                        else return isBefore(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'equal') {
                        return isEqual(cellValueFormattedDate, filterValueFormattedDate);
                    }
                    else return false;
                }
                else return true;
            }
            else return false;

        },
    },
    {
        columnName: 'DataUltimoAccesso',
        predicate: (cellValue, filter, row) => {

            if (!filter.value) return true;

            if (filter) {

                if (isValid(new Date(filter.value))) {
                    //pulisco le date dal time in modo da fare il check solo sulla data
                    var cellValueDate = null;
                    var cellValueFormattedDate = null;

                    if (cellValue !== null) {
                        var cellValueDate = new Date(cellValue);
                        var cellValueFormattedDate = parseISO(format(cellValueDate, 'yyyy-MM-dd'));
                    }

                    var filterValueFormattedDate = parseISO(format(filter.value, 'yyyy-MM-dd'));

                    if (filter.operation === 'greaterThan') {
                        //se cellValue === null allora la licenza non ha data scadenza
                        if (cellValue === null) return true;
                        else return isAfter(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'lessThan') {
                        if (cellValue === null) return false;
                        else return isBefore(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'equal') {
                        return isEqual(cellValueFormattedDate, filterValueFormattedDate);
                    }
                    else return false;
                }
                else return true;
            }
            else return false;

        },
    },
    {
        columnName: 'DataCreazione',
        predicate: (cellValue, filter, row) => {

            if (!filter.value) return true;

            if (filter) {

                if (isValid(new Date(filter.value))) {
                    //pulisco le date dal time in modo da fare il check solo sulla data
                    var cellValueDate = null;
                    var cellValueFormattedDate = null;

                    if (cellValue !== null) {
                        var cellValueDate = new Date(cellValue);
                        var cellValueFormattedDate = parseISO(format(cellValueDate, 'yyyy-MM-dd'));
                    }

                    var filterValueFormattedDate = parseISO(format(filter.value, 'yyyy-MM-dd'));

                    if (filter.operation === 'greaterThan') {
                        //se cellValue === null allora la licenza non ha data scadenza
                        if (cellValue === null) return true;
                        else return isAfter(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'lessThan') {
                        if (cellValue === null) return false;
                        else return isBefore(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'equal') {
                        return isEqual(cellValueFormattedDate, filterValueFormattedDate);
                    }
                    else return false;
                }
                else return true;
            }
            else return false;

        },
    },
    {
        columnName: 'DataAccesso',
        predicate: (cellValue, filter, row) => {

            if (!filter.value) return true;

            if (filter) {

                if (isValid(new Date(filter.value))) {
                    //pulisco le date dal time in modo da fare il check solo sulla data
                    var cellValueDate = null;
                    var cellValueFormattedDate = null;

                    if (cellValue !== null) {
                        var cellValueDate = new Date(cellValue);
                        var cellValueFormattedDate = parseISO(format(cellValueDate, 'yyyy-MM-dd'));
                    }

                    var filterValueFormattedDate = parseISO(format(filter.value, 'yyyy-MM-dd'));

                    if (filter.operation === 'greaterThan') {
                        //se cellValue === null allora la licenza non ha data scadenza
                        if (cellValue === null) return true;
                        else return isAfter(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'lessThan') {
                        if (cellValue === null) return false;
                        else return isBefore(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'equal') {
                        return isEqual(cellValueFormattedDate, filterValueFormattedDate);
                    }
                    else return false;
                }
                else return true;
            }
            else return false;

        },
    },
    {
        columnName: 'DataOperation',
        predicate: (cellValue, filter, row) => {

            if (!filter.value) return true;

            if (filter) {

                if (isValid(new Date(filter.value))) {
                    //pulisco le date dal time in modo da fare il check solo sulla data
                    var cellValueDate = null;
                    var cellValueFormattedDate = null;

                    if (cellValue !== null) {
                        var cellValueDate = new Date(cellValue);
                        var cellValueFormattedDate = parseISO(format(cellValueDate, 'yyyy-MM-dd'));
                    }

                    var filterValueFormattedDate = parseISO(format(filter.value, 'yyyy-MM-dd'));

                    if (filter.operation === 'greaterThan') {
                        //se cellValue === null allora la licenza non ha data scadenza
                        if (cellValue === null) return true;
                        else return isAfter(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'lessThan') {
                        if (cellValue === null) return false;
                        else return isBefore(cellValueFormattedDate, sub(filterValueFormattedDate, { minutes: 1 }));
                    }
                    else if (filter.operation === 'equal') {
                        return isEqual(cellValueFormattedDate, filterValueFormattedDate);
                    }
                    else return false;
                }
                else return true;
            }
            else return false;

        },
    },
];

export const FilterIcon = ({ type, ...restProps }) => {
    if (type === 'greaterThan') return <LessThan {...restProps} />;
    else if (type === 'lessThan') return <GreaterThan {...restProps} />;
    else if (type === 'equal') return <Equals {...restProps} />;
    return <TableFilterRow.Icon type={type} {...restProps} />;
};


//Personalizzazione valori colonne

const dateFilterOperations = ['equal', 'lessThan', 'greaterThan'];

// Date
const DateFormatter = ({ value }) => {
    if (value !== undefined && value !== null)
        return format(parseISO(value), 'dd/MM/yyyy');
    else return null;
};

export const DateTypeProvider = props => (
    <DataTypeProvider
        formatterComponent={DateFormatter}
        availableFilterOperations={dateFilterOperations}
        {...props}
    />
);


// DateTime
const DateTimeFormatter = ({ value }) => {
    if (value !== undefined && value !== null)
        return format(parseISO(value), 'dd/MM/yyyy HH:mm');
    else return null;
};

export const DateTimeTypeProvider = props => (
    <DataTypeProvider
        formatterComponent={DateTimeFormatter}
        availableFilterOperations={dateFilterOperations}
        {...props}
    />
);

// Stato
const StatoLicenzaFormatterBase = ({ value, classes }) =>
    <div className={classes.alignCenter}>
        <Chip className={value === 'true' ? classes.licenzaBloccata : classes.licenzaAttiva}
            label={value === 'true' ? 'Bloccata' : 'Attiva'} />
    </div>;

const StatoLicenzaFormatter = withStyles(styles, { name: 'StatoLicenzaFormatter' })(StatoLicenzaFormatterBase);

export const StatoLicenzaTypeProvider = props => (
    <DataTypeProvider
        formatterComponent={StatoLicenzaFormatter}
        {...props}
    />
);



// MultiAzienda
const MultiAziendaFormatterBase = ({ value, classes }) =>
    <div className={classes.alignCenter}>
        <CheckBox className={value === 'true' ? classes.checkBoxMultiAzienda : null}
            value={value === 'true' ? true : false}
            readOnly
        />
    </div>;

const MultiAziendaFormatter = withStyles(styles, { name: 'MultiAziendaFormatter' })(MultiAziendaFormatterBase);

export const MultiAziendaTypeProvider = props => (
    <DataTypeProvider
        formatterComponent={MultiAziendaFormatter}
        {...props}
    />
);



const GridDetailContainerBase = ({ row, classes }) => (
    <div className={classes.detailContainer}>
        {/* <RowDetails infoAttivita={row} /> */}
    </div>
);

export const DetailsContainer = withStyles(styles, { name: 'DetailsContainer' })(GridDetailContainerBase);


// Personalizzazione celle filtri
const FilterCellComponentBase = ({
    filter,
    onFilter,
    classes,
    column,
    children,
    ...restProps
}) => {

    if (column.name === "Tipologia") {

        const tipologie = [{ id: 0, display: "Enterprise" }, { id: 1, display: "ERP" }];

        return (
            <TableCell>
                <Select className={classes.alignCenter}
                    disableUnderline
                    value={filter ? filter.value : ""}
                    onChange={e => {
                        onFilter(e.target.value ? { value: e.target.value, operation: 'equal' } : null);
                    }}
                    inputProps={{
                        name: "Partners"
                    }}
                >
                    <MenuItem value={""}>All</MenuItem>
                    {tipologie.map(item => {
                        return (
                            <MenuItem value={item.display} key={item.id}>
                                {item.display}
                            </MenuItem>
                        );
                    })}
                </Select>
            </TableCell>
        );
    }
    else if (column.name === "Bloccata") {

        const tipologie = [{ id: 0, display: "Attiva", value: 'false' }, { id: 1, display: "Bloccata", value: 'true' }];

        return (
            <TableCell>
                <Select className={classes.alignCenter}
                    value={filter ? filter.value : ""}
                    onChange={e => {
                        onFilter(e.target.value ? { value: e.target.value, operation: 'equal' } : null);
                    }}
                >
                    <MenuItem value={""}>All</MenuItem>
                    {tipologie.map(item => {
                        return (
                            <MenuItem value={item.value} key={item.id}>
                                {item.display}
                            </MenuItem>
                        );
                    })}
                </Select>
            </TableCell>
        );
    }
    else if (column.name === "MultiAzienda") {

        const tipologie = [{ id: 0, display: "All", value: '' }, { id: 1, display: "Si", value: 'true' }, { id: 2, display: "No", value: 'false' }];

        return (
            <TableCell>
                <Select className={classes.alignCenter}
                    value={filter ? filter.value : ""}
                    onChange={e => { onFilter(e.target.value ? { value: e.target.value, operation: 'equal' } : null); }}
                >

                    {tipologie.map(item => {
                        return (
                            <MenuItem value={item.value} key={item.id}>
                                {item.display}
                            </MenuItem>
                        );
                    })}
                </Select>
            </TableCell>
        );
    }
    else if (column.name === "DataScadenza" || column.name === "DataDecorr" || column.name === "DataAttivazione" ||
        column.name === "DataUltimoAccesso" || column.name === "DataCreazione" || column.name === "DataAccesso" || column.name === "DataOperation") {

        return (
            <TableFilterRow.Cell {...restProps} >
                {children[0]}
                {<CustomDateFilter
                    value={filter ? filter.value : null}
                    onChange={e => {
                        onFilter(e ? { value: e, operation: filter ? filter.operation : 'equal' } : null);
                    }}
                />}
            </ TableFilterRow.Cell>
        );
    }


    return (
        <TableFilterRow.Cell {...restProps} >
            {children[0]}
            {children[1]}
        </ TableFilterRow.Cell>
    );

};

export const FilterCellComponent = withStyles(styles, { name: 'FilterCellComponent' })(FilterCellComponentBase);